import { createDecoratedTheme } from '../createDecoratedTheme'

export default createDecoratedTheme({
    name: 'mexicoEmerald',
    label: 'México esmeralda',
    art: {
        background: require('./images/background.png'),
        frame: require('./images/frame.png'),
        icons: require('./images/icons.png'),
        homeActivityIcons: require('./images/home-activity-icons-v3.png'),
        auth: require('./images/auth.png'),
        sidebar: require('./images/sidebar-v2.png'),
        hero: require('./images/hero-scene-v2.png'),
        eventChest: require('./images/event-chest-v1.png'),
        eventBackdrop: require('./images/event-backdrop-v1.png'),
        pageTexture: require('./images/page-texture-v1.png'),
        eventThumbnails: require('./images/event-thumbnails-v1.png'),
        activityScenes: require('./images/activity-scenes-v1.png'),
        scratchFrame: require('./images/scratch-frame-v1.png'),
        wheelRim: require('./images/wheel-rim-v1.png'),
        wheelPointer: require('./images/wheel-pointer-v1.png'),
        wheelHub: require('./images/wheel-hub-v1.png'),
        vipIcons: require('./images/vip-icons-v1.png'),
        detailIcons: require('./images/detail-icons-v1.png'),
        vipEmblem: require('./images/vip-emblem-v1.png'),
        vipCalendar: require('./images/vip-calendar-v1.png'),
        walletGift: require('./images/wallet-gift-scene-v1.png'),
        walletTreasure: require('./images/wallet-treasure-scene-v1.png'),
        walletLock: require('./images/wallet-lock-scene-v1.png'),
        rankingTrophy: require('./images/ranking-trophy-v1.png'),
        paymentScenes: require('./images/payment-scenes-v1.png'),
        affiliateMegaphone: require('./images/affiliate-megaphone-v1.png'),
        affiliatePosters: require('./images/affiliate-posters-v1.png')
    },
    colors: {
        'page-bg': '#073B35',
        surface: '#11574B',
        raised: '#174D42',
        input: '#062F2A',
        border: '#8D793E',
        text: '#FFF5DB',
        muted: '#C9DCD2',
        primary: '#C34730',
        gold: '#E9B54A',
        selected: '#195A45',
        'on-primary': '#FFF5DB',
        disabled: '#38544B',
        button: 'linear-gradient(180deg, #C34730 0%, #A93624 100%)',
        selection: 'linear-gradient(180deg, #286B50 0%, #124D3C 100%)'
    }
})
